<!--

    Copyright (C) 2023 Das Land Schleswig-Holstein vertreten durch den
    Ministerpräsidenten des Landes Schleswig-Holstein
    Staatskanzlei
    Abteilung Digitalisierung und zentrales IT-Management der Landesregierung

    Lizenziert unter der EUPL, Version 1.2 oder - sobald
    diese von der Europäischen Kommission genehmigt wurden -
    Folgeversionen der EUPL ("Lizenz");
    Sie dürfen dieses Werk ausschließlich gemäß
    dieser Lizenz nutzen.
    Eine Kopie der Lizenz finden Sie hier:

    https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12

    Sofern nicht durch anwendbare Rechtsvorschriften
    gefordert oder in schriftlicher Form vereinbart, wird
    die unter der Lizenz verbreitete Software "so wie sie
    ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
    ausdrücklich oder stillschweigend - verbreitet.
    Die sprachspezifischen Genehmigungen und Beschränkungen
    unter der Lizenz sind dem Lizenztext zu entnehmen.

-->
<div mat-dialog-title data-test-id="dialog-header" class="py-1">
  <span>{{ data.title }}</span>
  <div class="flex">
    <ods-button
      dataTestId="min-max-button"
      class="[&_button:focus-visible]:-outline-offset-2"
      variant="ghost"
      size="fit"
      icon="minimize"
      [iconConfig]="{ fill: 'whitetext' }"
      (clicked)="minimize()"
      [ariaLabel]="isMinimized ? 'Nachricht maximieren' : 'Nachricht minimieren'"
      [ariaExpanded]="!isMinimized"
    />

    <ods-button
      dataTestId="close-button"
      class="[&_button:focus-visible]:-outline-offset-2"
      variant="ghost"
      size="fit"
      icon="close"
      [iconConfig]="{ fill: 'whitetext' }"
      [mat-dialog-close]="true"
      ariaLabel="Nachricht schließen"
    />
  </div>
</div>

<mat-dialog-content [ngClass]="{ minimized: isMinimized }" data-test-id="dialog-content">
  <ng-container *ngComponentOutlet="data.component; injector: componentInjector"></ng-container>
</mat-dialog-content>
